import React from "react";
import { Link } from "react-router-dom";
import Seo, { breadcrumbJsonLd } from "@/components/Seo";
import { Breadcrumbs, StarRating } from "@/components/common";
import ReviewsCarousel from "@/components/ReviewsCarousel";
import { SITE } from "@/mock";

export default function About() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
  ];
  return (
    <>
      <Seo
        title="About MattressTown - Family-Owned in Fort Lauderdale"
        description="MattressTown is a family-owned mattress store in Fort Lauderdale, FL, known for honest pricing, premium brands and same-day delivery."
        path="/about"
        jsonLd={breadcrumbJsonLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />

      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid items-center gap-8 sm:gap-10 lg:grid-cols-2">
          <div>
            <h1 className="text-4xl font-bold uppercase text-neutral-900">Our Story</h1>
            <p className="mt-4 leading-relaxed text-neutral-600">
              MattressTown is a family-owned and operated mattress store proudly
              serving Fort Lauderdale, and all of Dade, Broward and Palm Beach
              counties. We believe a great
              night's sleep shouldn't come with a hard sell or a confusing price
              tag. That's why we offer premium, name-brand mattresses at honest
              prices - backed by same-day delivery, professional set-up and
              old-mattress removal.
            </p>
            <p className="mt-4 leading-relaxed text-neutral-600">
              When you walk into our showroom, you're treated like family. Our
              specialists take the time to understand how you sleep and guide you
              to the perfect mattress - whether that's a luxurious Beautyrest
              Black, an award-winning Puffy or a dependable Serta.
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm font-semibold text-neutral-700"><StarRating value={5} /> {SITE.rating.toFixed(1)} · {SITE.reviewCount} Google Reviews</p>
          </div>
          <img src={SITE.storePhotos[1]} alt="MattressTown storefront in Fort Lauderdale, Florida with American flags" className="aspect-[4/3] w-full rounded-2xl object-cover" />
        </div>

        {/* Showroom location map */}
        <section className="mt-10 sm:mt-16">
          <h2 className="text-2xl font-bold uppercase text-neutral-900">Our Fort Lauderdale Showroom</h2>
          <p className="mt-2 max-w-3xl text-neutral-600">Stop by our store on N Federal Highway to see and feel our full lineup of premium mattresses in person.</p>
          <div className="mt-6 overflow-hidden rounded-2xl border border-neutral-200" data-testid="about-map">
            <iframe
              title="Map to MattressTown, Fort Lauderdale"
              src={`https://www.google.com/maps?q=${encodeURIComponent(SITE.address.full)}&z=11&output=embed`}
              className="h-[360px] w-full border-0 sm:h-[420px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </section>

        {/* Rotating Google reviews */}
        <section className="mt-10 rounded-3xl bg-neutral-100 px-4 py-10 sm:mt-16 sm:px-8 sm:py-14">
          <div className="text-center">
            <p className="mb-2 text-sm font-bold uppercase tracking-widest text-[#D0021B]">
              Loved by Our Customers
            </p>
            <h2 className="text-2xl font-bold uppercase text-neutral-900 sm:text-3xl">
              What Fort Lauderdale Is Saying
            </h2>
          </div>
          <div className="mt-6 sm:mt-10">
            <ReviewsCarousel />
          </div>
        </section>

        <div className="mt-10 rounded-2xl bg-cream p-6 text-center sm:mt-12 sm:p-8">
          <h2 className="text-2xl font-bold uppercase text-neutral-900">Come Say Hello</h2>
          <p className="mx-auto mt-2 max-w-xl text-neutral-600">Visit our Fort Lauderdale showroom at {SITE.address.full}.</p>
          <Link to="/locations" className="mt-5 inline-block rounded-full bg-[#D0021B] px-8 py-3 text-sm font-bold uppercase tracking-wide text-white hover:bg-[#a80016]">Find Our Store</Link>
        </div>
      </div>
    </>
  );
}
